import React, { useEffect, useState, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getTodayFailedLoginsAPI } from "../Service/apiService";

const FailedLoginTable = () => {
  const { date } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

useEffect(() => {
  const fetchFailedLogins = async () => {
    if (!date) {
      setLoading(false);
      setData([]);
      return;
    }

    setLoading(true);
    try {
      //pass the date too
      const res = await getTodayFailedLoginsAPI(date);
      setData(res?.data || []);
    } catch (error) {
      console.error("Failed to fetch logs for date:", date, error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  fetchFailedLogins();
}, [date]);

  // Memoize filtered data for performance
  const filteredData = useMemo(() => {
    if (!searchTerm) return data;

    const term = searchTerm.toLowerCase().trim();
    return data.filter((row) => {
      const email = row.message.split(" ")[0]?.toLowerCase() || "";
      const category = (row.category || "").toLowerCase();
      const message = (row.message || "").toLowerCase();
      const time = new Date(row.createdAt).toLocaleString().toLowerCase();

      return (
        email.includes(term) ||
        category.includes(term) ||
        message.includes(term) ||
        time.includes(term)
      );
    });
  }, [data, searchTerm]);

  return (
    <div className="failed-login-page">
      <button className="back-btn" onClick={() => navigate(-1)}>
        ← Back
      </button>

      <h2>Failed Login Attempts — {date}</h2>

      {/* Search Bar */}
      <div className="search-bar">
        <input
          type="text"
          placeholder="Search by email, category, message, or time..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>

      <div className="table-wrapper scrollable-table">
        <table className="custom-table">
          <thead>
            <tr>
              <th>Email</th>
              <th>Category</th>
              <th>Message</th>
              <th>Time</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="4" className="text-center">Loading...</td>
              </tr>
            ) : filteredData.length > 0 ? (
              filteredData.map((row) => (
                <tr key={row._id || row.createdAt + Math.random()}>
                  <td>{row.message.split(" ")[0]}</td>
                  <td>{row.category}</td>
                  <td>{row.message}</td>
                  <td>{new Date(row.createdAt).toLocaleString()}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center">
                  {searchTerm
                    ? `No results for "${searchTerm}"`
                    : "No failed logins found"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FailedLoginTable;